






import Vue from 'vue'
import Component from 'vue-class-component'
import { Inject, Prop } from 'vue-property-decorator'
import { Step } from '@/shared/interfaces/step'
import { Validation } from '@/shared/forms/validation'
import { loggerFor } from '@/shared/utils/logger'
import { FormGroup } from '@/shared/forms/form-group'

@Component
export default class RespondecoStep extends Vue implements Step {
  @Prop({
    type: String,
  })
  public readonly control?: string

  @Prop({
    type: String,
  })
  public readonly id?: string

  @Prop({
    required: false,
    type: String,
  })
  public readonly title?: string

  @Inject()
  public readonly form?: FormGroup<any>

  private logger = loggerFor('RespondecoStep')

  get formControl(): Validation | undefined {
    let control: Validation | undefined

    if (this.control) {
      if (this.form === undefined) {
        this.logger.warn(`No form control named '${this.control}' found`)
      } else {
        control = this.form.field(this.control)
      }
    }

    return control
  }

  get invalid(): boolean {
    return this.formControl?.$invalid ?? false
  }
}
